"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-use-before-define */
const richeditor_form_1 = __importDefault(require("./richeditor.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const sdk_1 = require("@ariform/core/sdk");
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class RichEditorComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.dataName = '';
        this.dataOpions = [];
        this.selectItemArr = [];
        this.editor = '';
        this.editorContent = '';
        this.suggestData = [];
        sdk_1.AriForm.requireLibrary('jodit-css', 'jodit', [
            { type: 'styles', src: `${sdk_1.AriForm.cdn.baseUrl}/jodit/jodit.min.css` }
        ], true);
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'richEditor',
            label: 'Rich Editor',
            dataSrc: 'aripost',
            dataSourcePath: 'dataSource',
            defaultRulePath: 'rule',
            displayInfo: true,
            defaultRule: '',
            formulaDataSource: '',
            align: 'justify-content-start',
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return RichEditorComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    get inputInfo() {
        const info = super.inputInfo;
        return info;
    }
    get selectItem() {
        const selectItem = this.selectItemArr;
        return selectItem;
    }
    render() {
        var view = `<textarea ref="${this.component.key}-rich-editor" name="editor"></textarea>`;
        return super.render(view);
    }
    setValue(value, flags = {}) {
        const changed = super.setValue(value, flags);
        if (changed) {
            if (this.editor) {
                this.editor.value = value;
                this.editorContent = value;
            }
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        const superAttach = super.attach(element);
        var refs = {};
        refs[`${this.component.key}-rich-editor`] = 'single';
        this.loadRefs(element, refs);
        const initEditor = () => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-undef
            Jodit.defaultOptions.controls.suggest = {
                tooltip: 'Insert variable from list',
                icon: 'info-circle',
                exec: (editor) => {
                    // Gọi API khi người dùng nhấn nút suggest
                    const renderDialog = (suggestData) => {
                        // eslint-disable-next-line no-undef
                        const dialog = new Jodit.modules.Dialog({
                            fullsize: false,
                            resizable: false,
                        });
                        // Tạo nội dung danh sách
                        const listContainer = editor.create.fromHTML(`
                            <div style="padding: 10px; max-width: 300px;">
                                <ul style="list-style: none; padding: 0; margin: 0;">
                                    ${suggestData
                            .map((item) => `<li 
                                                    data-index="${item.id}" 
                                                    style="padding: 8px; cursor: pointer; border: 1px solid #ddd; margin-bottom: 5px; border-radius: 4px; background: #f9f9f9;"
                                                >
                                                    ${item.title}
                                                </li>`)
                            .join('')}
                                </ul>
                            </div>
                        `);
                        listContainer.querySelectorAll('li').forEach((listItem) => {
                            listItem.addEventListener('click', () => {
                                const selectedItem = listItem.getAttribute('data-index');
                                editor.s.insertHTML(`{{${selectedItem}}}`); // Chèn nội dung vào editor
                                dialog.close(); // Đóng dialog
                            });
                        });
                        dialog.setHeader('Choose an Item');
                        dialog.setContent(listContainer);
                        dialog.open();
                    };
                    if (this.suggestData.length > 0) {
                        renderDialog(this.suggestData);
                    }
                    else {
                        sdk_1.AriForm.makeAriStaticRequest(`${sdk_1.AriForm.baseUrl}/${sdk_1.AriForm.serviceId}/${'notifi/suggest'}`, 'POST', {}, {})
                            .then((result) => {
                            this.suggestData = result; // Lưu dữ liệu từ API
                            // Tạo dialog mới
                            renderDialog(result);
                        })
                            .catch((error) => {
                            console.error('Error fetching suggestions:', error);
                        });
                    }
                },
            };
        });
        const joditScriptUrl = `${sdk_1.AriForm.cdn.baseUrl}/jodit/jodit.min.js`;
        sdk_1.AriForm.requireLibrary('jodit', 'Jodit', joditScriptUrl, true).then((Jodit) => {
            initEditor();
            if (this.refs[`${this.component.key}-rich-editor`]) {
                // eslint-disable-next-line no-undef
                this.editor = Jodit.make(this.refs[`${this.component.key}-rich-editor`], {
                    showTooltip: true,
                    height: 400,
                    hidePoweredByJodit: true,
                    allowResizeY: true,
                    showCharsCounter: false,
                    showWordsCounter: false,
                    disabled: this.component.disabled,
                    toolbarAdaptive: false,
                    readonly: false,
                    toolbar: true,
                    buttons: [
                        'suggest', '|', 'bold', 'strikethrough', 'underline', 'italic', 'eraser', '|', 'superscript', 'subscript', '|', 'ul', 'ol', 'align', '|', 'outdent', 'indent', '|', 'font', 'fontsize', 'brush', 'paragraph', '|', 'image', 'video', 'table', 'link', '|', 'undo', 'redo', 'selectall', 'cut', 'copy', 'paste', 'copyformat', '|', 'hr', 'source', 'fullsize', 'print', 'symbols', 'spellcheck',
                    ],
                });
                // this.editor.selection.insertHTML(this.editorContent);
                this.editor.events.on('change', () => {
                    this.setValue(this.editor.value);
                });
                this.editor.value = this.editorContent;
            }
        });
        return superAttach;
    }
    updateValue(...args) {
        return this.updateComponentValue(...args);
    }
}
RichEditorComponent.editForm = richeditor_form_1.default;
RichEditorComponent.builderInfo = {
    title: 'Rich Editor',
    group: 'advanced',
    icon: 'list-alt',
    weight: 70,
    documentation: 'http://help.ari.form/userguide/',
    schema: RichEditorComponent.schema()
};
exports.default = RichEditorComponent;
